import React from "react";
import { Route, Routes } from "react-router-dom";
import LoanLayout from "./LoanLayout";
import Layout from "./Layout";
import ScrollToTop from "./components/ScrollTop";
import UtmPersist from "./components/UtmPersist";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import ShortLoan from "./pages/ShortLoan";
import InstantLoan from "./pages/InstantLoan";
import FAQ from "./pages/FAQ";
import RateandTerms from "./pages/RateandTerms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsandConditions from "./pages/TermsandConditions";
import Ahmedabad from "./pages/locations/Ahmedabad";
import Hyderabad from "./pages/locations/Hyderabad";
import Mumbai from "./pages/locations/Mumbai";
import Banglore from "./pages/locations/Banglore";
import Delhi from "./pages/locations/Delhi";
import RepayLoan from "./pages/RepayLoan";
import VerifyRepayOtp from "./pages/VerifyRepayOtp";
import Flexibility from "./pages/Flexibility";
import DebtConsolidation from "./pages/DebtConsolidation";
import MinimalCommitment from "./pages/MinimalCommitment";
import CostEffective from "./pages/CostEffective";
import Home from "./pages/Home";
import LendingPage from "./components/LendingPage";
import DashBoard from "./pages/Dashboard/DashBoard";
import PanDetails from "./pages/Dashboard/PanDetails/PanDetails";
import CapturAddress from "./pages/Dashboard/CapturAddress/CapturAddress";
import CapturPersonalInformation from "./pages/Dashboard/CapturPersonalInformation/CapturPersonalInformation";
import CapturIncomeDetails from "./pages/Dashboard/CapturIncomeDetails/CapturIncomeDetails";
// import UploadPicture from "./pages/Dashboard/UploadPicture/UploadPicture";
import ProfilePage from "./pages/Dashboard/ProfilePage/ProfilePage";
import ProfilePreview from "./pages/Dashboard/ProfilePage/ProfilePreview";
import CalculateLoan from "./pages/Dashboard/CalculateLoan/CalculateLoan";
import AboutCompany from "./pages/Dashboard/AboutCompany/AboutCompany";
import Ekyc from "./pages/Dashboard/Ekyc/Ekyc";
// import UploadBankStatement from "./pages/Dashboard/UploadBankStatement/UploadBankStatement";
import Eligibility from "./pages/Dashboard/Eligibility/Eligibility";
// import ProtectedRoute from "./components/ProtectedRoute";
import PanUpload from "./pages/Dashboard/PanUpload/PanUpload";
import DocumentUpload from "./pages/Dashboard/DocumentUpload/DocumentUpload";
// import ThankYou from "./pages/Dashboard/ThankYou/ThankYou";
import UploadSalaryslip from "./pages/Dashboard/UploadSalaryslip/UploadSalaryslip";
import UploadUtilitybill from "./pages/Dashboard/UploadUtilitybill/UploadUtilitybill";
import LeadPreview from "./pages/Dashboard/ProfilePage/LeadPreview";
import LoanHistory from "./pages/LoanHistory/LoanHistory";
import LoanDetail from "./pages/LoanHistory/LoanDetail"
import RepayPage from "./pages/Dashboard/ProfilePage/RepayPage";
import BankDetail from "./pages/Dashboard/BankDetail/BankDetail";
import Ghaziabad from "./pages/locations/Ghaziabad";
import Noida from "./pages/locations/Noida";
import Faridabad from "./pages/locations/Faridabad";
import GreaterNoida from "./pages/locations/GreaterNoida";
import Gurgaon from "./pages/locations/Gurgaon";
import RepayThankyou from "./pages/RepayThanku";
import CancellationRefundPolicy from "./pages/CancellationRefundPolicy";
import SecurityAlert from "./pages/SecurityAlert";
import GrievanceRedressalMechanism from "./pages/GrievanceRedressalMechanism";
import TailwindTest from "./pages/TailwindTest";
import OTP from "./pages/automation/OTP";
import PANDetails from "./pages/automation/PANDetails";
import UploadPicture from "./pages/automation/UploadPicture";
import RegisterNow from "./pages/automation/RegisterNow";
import OtherInformation from "./pages/automation/OtherInformation";
import AccountAggregator from "./pages/automation/AccountAggregator";
import AccountAggregatorRedirect from "./pages/automation/AccountAggregatorRedirect";
import BankingDetails from "./pages/automation/BankingDetails";
import EKyc from "./pages/automation/EKyc";
import VerifyDigilockerEkyc from "./pages/automation/VerifyDigilockerEkyc";
import KycCompleted from "./pages/automation/KycCompleted";
import ThankYou from "./pages/automation/ThankYou";
import Congratulations from "./pages/automation/Congratulations";
import BankStatementUpload from "./pages/automation/BankStatementUpload";
import NotFound from "./pages/automation/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";

// GC / Loan-Aggregator SSO pages
import SsoLanding from "./pages/SsoLanding";
import PartialEmployment from "./pages/PartialEmployment";

// import PayUTest from "./pages/PayUTest";


// Automation Node Routes
import PanMobile from './pages/automationNode/PanMobile';
import OTPMobile from './pages/automationNode/OTPMobile';
import Employment from './pages/automationNode/Employment';
import Email from './pages/automationNode/Email';
import AadharAutomation from './pages/automationNode/Aadhar';
import LoanAmountAutomation from './pages/automationNode/LoanAmount';
import PreEsignAutomation from './pages/automationNode/PreEsign';
import EsignAutomation from './pages/automationNode/Esign';
import Disbursal2Automation from './pages/automationNode/Disbursal2';
import ThankYouCard from './pages/automationNode/ThankYouCard';
import ApplicationRejected from './pages/automationNode/ApplicationRejected';
import References from './pages/automationNode/References';
import KycDocuments from './pages/automationNode/KycDocuments';
import UploadBankStatement from './pages/automationNode/UploadBankStatement';
import DashboardAutomation from './pages/automationNode/Dashboard';
import AccountAggregatorDigitapp from './pages/automationNode/AccountAggregatorDigitapp';
import PostAccountAggregatorDigitapp from './pages/automationNode/PostAccountAggregatorDigitapp';


const showmessage = async (message) => {
  try {
    var x = document.getElementById("snackbar");
    x.className = "show";
    x.innerText = message;
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  } catch (error) {
    console.log(error);
  }
};

function Router() {
  return (
    <>
      <UtmPersist />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="about-us" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="contact" element={<Contact />} />
          <Route path="lending" element={<LendingPage />} />
          <Route path="cancelation-refund" element={<CancellationRefundPolicy />} />
          <Route path="short-term-loan" element={<ShortLoan />} />
          <Route path="instant-loan" element={<InstantLoan />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="rateandterms" element={<RateandTerms />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-condition" element={<TermsandConditions />} />
          <Route path="security-alert" element={<SecurityAlert />} />
          <Route path="grievance-redressal-mechanism" element={<GrievanceRedressalMechanism />} />
          <Route path="Instant-Personal-Loan-for-Salaried-in-Delhi" element={<Delhi />} />
          <Route path="advance-loans-Online-in-Bangalore" element={<Banglore />} />
          <Route path="loan-agency-in-mumbai" element={<Mumbai />} />
          <Route path="instant-personal-loan-in-ahmedabad" element={<Ahmedabad />} />
          <Route path="instant-personal-loan-online-in-hyderabad" element={<Hyderabad />} />
          <Route path="personal-loan-in-Gurgaon" element={<Gurgaon />} />
          <Route path="Personal-loan-in-Noida" element={<Noida />} />
          <Route path="personal-loan-in-faridabad" element={<Faridabad />} />
          <Route path="instant-personal-loan-in-greater-noida" element={<GreaterNoida />} />
          <Route path="Instant-Personal-Loan-in-Ghaziabad" element={<Ghaziabad />} />
          <Route path="flexibility" element={<Flexibility />} />
          <Route path="debt-consolidation-loan" element={<DebtConsolidation />} />
          <Route path="minimalcommitment" element={<MinimalCommitment />} />
          <Route path="costeffective" element={<CostEffective />} />
          <Route path="thanku" element={<RepayThankyou/>}/>
          <Route path="repayloan" element={<RepayLoan />} />
          <Route path="verify-repay-otp" element={<VerifyRepayOtp />} />
          <Route path="tailwind-test" element={<TailwindTest />} />

          <Route path="otp" element={<OTP />} />
          <Route path="pan-details" element={<ProtectedRoute><PANDetails /></ProtectedRoute>} />
          <Route path="upload-picture" element={<ProtectedRoute><UploadPicture /></ProtectedRoute>} />
          <Route path="register-now" element={<ProtectedRoute><RegisterNow /></ProtectedRoute>} />
          <Route path="other-information" element={<ProtectedRoute><OtherInformation /></ProtectedRoute>} />
          <Route path="account-aggregator" element={<ProtectedRoute><AccountAggregator /></ProtectedRoute>} />
          <Route path="account-aggregator-redirect" element={<ProtectedRoute><AccountAggregatorRedirect /></ProtectedRoute>} />
          <Route path="banking-details" element={<ProtectedRoute><BankingDetails /></ProtectedRoute>} />
          <Route path="e-kyc" element={<ProtectedRoute><EKyc /></ProtectedRoute>} />
          <Route path="verify-digilocker-ekyc" element={<ProtectedRoute><VerifyDigilockerEkyc /></ProtectedRoute>} />
          <Route path="kyc-completed" element={<KycCompleted />} />
          <Route path="new-page" element={<KycCompleted />} />
          <Route path="thank-you" element={<ProtectedRoute><ThankYou /></ProtectedRoute>} />
          <Route path="congratulations" element={<ProtectedRoute><Congratulations /></ProtectedRoute>} />
          <Route path="bank-statement-upload" element={<ProtectedRoute><BankStatementUpload /></ProtectedRoute>} />
          {/* <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} /> */}
          <Route path="*" element={<NotFound />} />


          {/* GC / Loan-Aggregator SSO landing (logs the user in from the redirect token) */}
          <Route path="/sso" element={<SsoLanding />} />

          {/* ==================== APPLICATION FLOW (PUBLIC) ==================== */}
          <Route path="/apply/pan-mobile" element={<PanMobile />} />
            <Route path="/apply-now" element={<PanMobile />} />
            <Route path="/apply/otp-mobile" element={<OTPMobile />} />
            <Route path="/apply/employment-status" element={<Employment />} />
            <Route path="/apply/partial-details" element={<ProtectedRoute><PartialEmployment /></ProtectedRoute>} />
            <Route path="/apply/email" element={<Email />} />
            <Route path="/apply/aadhar" element={<AadharAutomation />} />
            <Route path="/apply/loan-amount" element={<LoanAmountAutomation />} />
            <Route path="/apply/account-aggregator" element={< AccountAggregatorDigitapp/>} />
            <Route path="/apply/post-account-aggregator" element={<PostAccountAggregatorDigitapp />} />
            <Route path="/apply/pre-e-sign" element={<PreEsignAutomation />} />
            <Route path="/apply/e-sign" element={<EsignAutomation />} />
            <Route path="/apply/disbursal" element={<Disbursal2Automation />} />
            <Route path="/apply/thank-you" element={<ThankYouCard />} />
            <Route path="/apply/rejected" element={<ApplicationRejected />} />
            <Route path="/apply/references" element={<References />} />
            <Route path="/apply/kyc-documents" element={<KycDocuments />} />
            <Route path="/kyc-status" element={<KycCompleted />} />
            <Route path="/apply/upload-bank-statement" element={<UploadBankStatement />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardAutomation /></ProtectedRoute>} />
       
          {/* <Route path="payu-test" element={<PayUTest />} /> */}
        </Route>

        {/* <Route path="/my-dashboard" element={<LoanLayout />}>
          <Route path="/my-dashboard/" element={<DashBoard showmessage={showmessage} />} />
          <Route path="/my-dashboard/pan-details" element={<PanDetails />} />
          <Route path="/my-dashboard/captur-address" element={<CapturAddress />} />
          <Route path="/my-dashboard/captur-personal-information" element={<CapturPersonalInformation />} />
          <Route path="/my-dashboard/captur-income-details" element={<CapturIncomeDetails />} />
          <Route path="/my-dashboard/upload-picture" element={<UploadPicture />} />
          <Route path="/my-dashboard/user-profile" element={<ProfilePage />} />
          <Route path="/my-dashboard/profile-preview" element={<ProfilePreview />} />
          <Route path="/my-dashboard/calculate-loan" element={<CalculateLoan />} />
          <Route path="/my-dashboard/about-your-company" element={<AboutCompany />}/>
          <Route path="/my-dashboard/bank-detail" element={<BankDetail />} />
          <Route path="/my-dashboard/kyc" element={<Ekyc />} />
          <Route path="/my-dashboard/bank-upload" element={<UploadBankStatement />} />
          <Route path="/my-dashboard/pan-upload" element={<PanUpload />} />
          <Route path="/my-dashboard/adhar-upload" element={<DocumentUpload />} />
          <Route path="/my-dashboard/congratulations" element={<ThankYou />} />
          <Route path="/my-dashboard/upload-salaryslip" element={<UploadSalaryslip />} />
          <Route path="/my-dashboard/upload-utilitybill" element={<UploadUtilitybill />} />
          <Route path="/my-dashboard/lead-preview" element={<LeadPreview />} />
          <Route path="/my-dashboard/leads" element={<LoanHistory />} />
          <Route path="/my-dashboard/repayment" element={<RepayPage />} />
          <Route path="/my-dashboard/details" element={<LoanDetail />} />

          
          <Route
            path="/my-dashboard/eligibility"
            element={
              <ProtectedRoute
                redirectTo="/my-dashboard"
                element={<Eligibility />}
              />
            }
          />
        </Route> */}
      </Routes>
    </>
  );
}

export default Router;



